import { useTranslation } from "react-i18next";

const COMP_C = { COMPLETE: "bg-emerald-50 text-emerald-700 border-emerald-200", ACTION_REQUIRED: "bg-amber-50 text-amber-700 border-amber-200",
  CRITICAL: "bg-red-50 text-red-700 border-red-200", INCOMPLETE: "bg-slate-100 text-slate-600 border-slate-200" };
const DOC_C = { VALID: "bg-emerald-50 text-emerald-700 border-emerald-200", EXPIRING: "bg-amber-50 text-amber-700 border-amber-200",
  REVIEW_REQUIRED: "bg-amber-50 text-amber-700 border-amber-200", EXPIRED: "bg-red-50 text-red-700 border-red-200",
  MISSING: "bg-slate-100 text-slate-600 border-slate-200" };
const ST_C = { DRAFT: "bg-slate-100 text-slate-600", READY_FOR_REVIEW: "bg-cyan/10 text-cyan-dark", FINAL: "bg-navy/10 text-navy",
  SIGNED: "bg-emerald-50 text-emerald-700", TERMINATED: "bg-red-50 text-red-700", ARCHIVED: "bg-slate-100 text-slate-400", SUPERSEDED: "bg-slate-100 text-slate-400" };

const pill = "inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold";

export function CompBadge({ v, testid }) {
  const { t } = useTranslation();
  if (!v) return <span className="text-slate-300">—</span>;
  return <span className={`${pill} ${COMP_C[v] || COMP_C.INCOMPLETE}`} data-testid={testid}>{t(`sc.comp.${v}`)}</span>;
}

export function DocBadge({ v, testid }) {
  const { t } = useTranslation();
  if (!v || v === "N/A") return <span className="text-slate-300">—</span>;
  return <span className={`${pill} ${DOC_C[v] || DOC_C.MISSING}`} data-testid={testid}>{t(`sc.docSt.${v}`)}</span>;
}

export function StatusBadge({ v, testid }) {
  const { t } = useTranslation();
  if (!v) return <span className="text-slate-300">—</span>;
  return <span className={`${pill} border-transparent ${ST_C[v] || ST_C.DRAFT}`} data-testid={testid}>{t(`sc.st.${v}`)}</span>;
}
